// Mock data for Naru Tofu website

export const companyInfo = {
  name: "NARU TOFU ORGANICS PRIVATE LIMITED",
  tagline: "Pure. Transparent. Preservative-Free.",
  description: "Bangalore's Premier Japanese Tofu Manufacturer Committed to Transparency and Quality.",
  billing: {
    address: "Om chambers, 648/A, 4th Floor, Binnamangala 1st Stage, Indiranagar, Bangalore, Karnataka, India, 560038",
    gst: "29AAKCN4113E1ZL"
  },
  manufacturing: {
    address: "Shop No 2, First Floor, Site No. 16 & 17, 1st Cross, Maruthi Layout, Katamnallur, Virgonagar Post, Bangalore - 560049",
    fssai: "21225009003858"
  },
  phone: "+91 85948 35784",
  email: "admin@narutofu.com"
};

export const product = {
  id: "momen-firm-tofu",
  name: "Momen Firm Tofu Block",
  description: "Traditional Japanese-style firm tofu, handcrafted with premium non-GMO soybeans. Perfect texture for grilling, frying, or adding to your favorite dishes.",
  weight: "300g",
  protein: "15.8g per 100g",
  features: [
    "Zero Cholesterol",
    "Non-GMO Soybeans",
    "Traditional Japanese Recipe",
    "High Protein Content",
    "Vegan & Gluten-Free",
    "No Artificial Additives"
  ],
  nutritionalInfo: {
    calories: "118 kcal",
    protein: "15.8g",
    carbohydrates: "3.4g",
    magnesium: "38.8mg",
    calcium: "154.2mg",
    iron: "1.3mg"
  }
};

export const healthBenefits = [
  {
    title: "High Quality Protein",
    description: "Complete protein source with all 9 essential amino acids, perfect for muscle building and repair."
  },
  {
    title: "Heart Health",
    description: "Zero cholesterol, low in saturated fat, and rich in omega-3 fatty acids, supporting heart health."
  },
  {
    title: "Bone Strength",
    description: "Excellent source of calcium and magnesium, essential for maintaining strong bones."
  },
  {
    title: "Weight Management",
    description: "Low calorie, high protein food that keeps you satiated longer while supporting lean muscle."
  },
  {
    title: "Hormone Balance",
    description: "Contains isoflavones that may help regulate hormones naturally."
  },
  {
    title: "Digestive Health",
    description: "Easy to digest plant-based protein suitable for sensitive stomachs."
  }
];

export const labReports = [
  {
    id: 1,
    title: "Nutritional Analysis & Microbiological Safety Report",
    date: "December 2025",
    lab: "TATTVA ANALYTICAL LABORATORIES LLP (NABL Certified)",
    highlights: [
      { metric: "Protein Content", naruValue: "15.8g/100g", industryStandard: "Min 8.0g/100g (FSSAI)", better: true },
      { metric: "Total Plate Count", naruValue: "1.2×10³ CFU/g", industryStandard: "Max 1.0×10⁴ CFU/g", better: true },
      { metric: "E. coli", naruValue: "Absent", industryStandard: "Absent", better: false },
      { metric: "Salmonella", naruValue: "Absent/25g", industryStandard: "Absent", better: false }
    ],
    downloadUrl: "https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/6yrrhkmq_NARU%20TOFU%20ORGANICS%20%283%29.pdf"
  },
  {
    id: 2,
    title: "Water Quality Test Report",
    date: "December 2025",
    lab: "TATTVA ANALYTICAL LABORATORIES LLP (NABL Certified)",
    highlights: [
      { metric: "pH Level", naruValue: "6.82", industryStandard: "6.5-8.5 (IS:10500:2012)", better: false },
      { metric: "TDS (Total Dissolved Solids)", naruValue: "58 mg/l", industryStandard: "Max 500 mg/l", better: true },
      { metric: "E. coli", naruValue: "<1 CFU/100ml", industryStandard: "Shall not be detectable", better: false },
      { metric: "Total Coliforms", naruValue: "<1 CFU/100ml", industryStandard: "Shall not be detectable", better: false }
    ],
    downloadUrl: "https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/yby9xddz_NARU%20TOFU%20ORGANICS%20-%20WATER%20%281%29.pdf"
  },
  {
    id: 3,
    title: "Shelf Life Study Report",
    date: "December 2025",
    lab: "TATTVA ANALYTICAL LABORATORIES LLP (NABL Certified)",
    highlights: [
      { metric: "Shelf Life (Refrigerated)", naruValue: "5 days at 0-4°C", industryStandard: "Varies by product", better: false },
      { metric: "Yeast & Mould (Day 5)", naruValue: "<10 CFU/g", industryStandard: "Shall not be detectable", better: false },
      { metric: "Total Coliform (7 days)", naruValue: "<10 CFU/g", industryStandard: "Shall not be detectable", better: false },
      { metric: "Sensory Quality", naruValue: "Acceptable through day 7", industryStandard: "Maintained quality", better: false }
    ],
    downloadUrl: "https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/uy4x0xql_NARU%20TOFU%20-%20Shelflife%20%281%29.pdf"
  },
  {
    id: 4,
    title: "Clinical Survey on Tofu Awareness & Health Benefits",
    date: "January 2026",
    lab: "Naru Tofu Organics - Clinical Nutrition Survey",
    highlights: [
      { metric: "Cardiovascular Health", naruValue: "Lower LDL cholesterol", industryStandard: "Plant-based benefits", better: true },
      { metric: "Insulin Sensitivity", naruValue: "Improved glycemic control", industryStandard: "Carb-heavy diets", better: true },
      { metric: "Safety Profile", naruValue: "Safe for general population", industryStandard: "Evidence-backed", better: false }
    ],
    downloadUrl: "https://customer-assets.emergentagent.com/job_transparent-tofu/artifacts/3m0odixp_Tofu_Clinical_Survey_2026%20%281%29.pdf"
  }
];

export const clinicalSurvey = {
  partner: "Clinical Nutrition Survey in collaboration with medical professionals",
  title: "Clinical Survey on Tofu Awareness & Health Benefits in Bangalore, India",
  duration: "Survey conducted in January 2026",
  participants: "East Point Hospital Medical Professionals in Bengaluru, India",
  keyFindings: [
    {
      statistic: "Evidence-Based",
      description: "Regular soy/tofu intake associated with lower LDL cholesterol and improved insulin sensitivity"
    },
    {
      statistic: "Cardiovascular",
      description: "Reduced cardiovascular risk compared to carb-dominant dietary patterns"
    },
    {
      statistic: "Safety Confirmed",
      description: "Moderate soy and tofu intake is safe for general population per systematic reviews"
    },
    {
      statistic: "Protein Quality",
      description: "Complete plant protein with all essential amino acids, zero cholesterol"
    }
  ],
  doctorQuote: "Indian diets are predominantly carbohydrate-rich and protein-inadequate. Replacing refined carbohydrates with plant-based proteins like tofu improves glycaemic control and lipid profiles, addressing India's metabolic health burden.",
  doctorName: "Clinical Nutrition Survey",
  doctorTitle: "Naru Tofu Organics Research Initiative 2026"
};

export const veganMovement = {
  title: "Championing Veganism in Bangalore",
  mission: "At Naru Tofu, we're not just producing tofu—we're leading a movement towards sustainable, compassionate living in Bangalore.",
  initiatives: [
    {
      title: "School & College Mess Partnerships",
      description: "Working with school and college mess teams to add tofu as a healthy, high-protein option in student meals."
    },
    {
      title: "Educational Programs",
      description: "Partnering with schools and colleges to raise awareness about sustainable food choices."
    },
    {
      title: "Defence & Hospital Food Programs",
      description: "Supporting defence mess facilities and hospitals with clean, zero-cholesterol tofu for balanced everyday meal plans."
    },
    {
      title: "Exclusive Japanese Cloud Kitchen",
      description: "Bangalore's first premium Japanese tofu & vegan cloud kitchen, bringing authentic plant-based Japanese cuisine to your doorstep."
    }
  ],
  impact: []
};

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Fitness Enthusiast",
    comment: "The quality and freshness of Naru Tofu is unmatched. I've tried many brands, but this is the only one that tastes authentic.",
    rating: 5
  },
  {
    id: 2,
    name: "Chef Akira Tanaka",
    role: "Japanese Restaurant Owner",
    comment: "Finally, authentic Japanese-style tofu in Bangalore! The texture and taste remind me of home.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Anjali Mehta",
    role: "Nutritionist",
    comment: "I recommend Naru Tofu to all my clients. The transparency in their processes and superior nutritional profile sets them apart.",
    rating: 5
  }
];

export const storeLocations = [
  "Nature's Basket - Indiranagar",
  "Organic World - Koramangala",
  "Fresh & Pure - Whitefield",
  "Green Market - HSR Layout",
  "Healthy Bites - Jayanagar",
  "Vegan Store - JP Nagar"
];
